import {CreateReducer} from '../utils/create_reducer';
import {
    CLEAR_DATA,
    GET_EXPENSE_ESTIMATE_DETAIL,
    GET_EXPENSE_DETAIL,
    GET_EXPENSE_ESTIMATES_LIST,
    GET_EXPENSE_LIST
} from "../actions/account_expense_action";

const initState = {
    expenses: [],
    estimates: [],
    isFetching: true,
    expenseDetail: undefined,
    estimateDetail: undefined
};

const accountExpenseReducer = CreateReducer(initState, {
    [GET_EXPENSE_LIST](state, action) {
        return {...state, expenses: action.payload, isFetching: false}
    },
    [GET_EXPENSE_ESTIMATES_LIST](state, action) {
        return {...state, estimates: action.payload, isFetching: false}
    },
    [GET_EXPENSE_DETAIL](state, action) {
        return {...state, expenseDetail: action.payload, isFetching: false}
    },
    [GET_EXPENSE_ESTIMATE_DETAIL](state, action) {
        return {...state, estimateDetail: action.payload, isFetching: false}
    },
    [CLEAR_DATA](state, action) {
        return {...initState}
    }
});

export default accountExpenseReducer;


// WEBPACK FOOTER //
// ./src/reducers/account_expense_reducer.js